module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-tooltip', _vm._b({
    ref: "tooltip",
    attrs: {
      "hide-after": 0,
      "popper-class": "id-tooltip",
      "effect": _vm.effect,
      "placement": _vm.placement,
      "offset": -20
    }
  }, 'el-tooltip', _vm.$attrs, false), [_c('div', {
    staticClass: "comp-indicator-description-content",
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_vm._t("default"), _vm._v(" "), _c('div', [_c('p', {
    style: ({
      'margin-bottom': _vm.desc.length !== 0 ? '10px' : '0px'
    })
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _vm._l((_vm.desc), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('span', [_vm._v(_vm._s(item.label))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.value))])])
  })], 2)], 2), _vm._v(" "), _c('div', {
    staticClass: "comp-indicator-description flex-between"
  }, [_vm._t("hover-btn", [_vm._v("指标说明")]), _vm._v(" "), _c('i', {
    staticClass: "icon-shuoming iconfont icon"
  })], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e875998"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui/IndicatorDescription/IndicatorDescription.vue
// module id = 184
// module chunks = 0